import * as React from "react";
export default class PillFilter extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { country, region, vintage, varietal } = this.props.currentFilter;
        const countryPills = country
            .split(',')
            .filter((x) => { return x.length > 0; })
            .map((item, index) => {
            return (React.createElement("li", { key: index, className: "filter-pills__list__item" },
                React.createElement("button", { className: "pill" },
                    React.createElement("span", null, item),
                    React.createElement("i", { onClick: () => { this.props.updateSubFilter(item.trim(), "country"); }, className: "fa fa-times", "aria-hidden": "true" }))));
        });
        const regionPills = region
            .split(',')
            .filter((x) => { return x.length > 0; })
            .map((item, index) => {
            return (React.createElement("li", { key: index, className: "filter-pills__list__item" },
                React.createElement("button", { className: "pill" },
                    React.createElement("span", null, item),
                    React.createElement("i", { onClick: () => { this.props.updateSubFilter(item.trim(), "region"); }, className: "fa fa-times", "aria-hidden": "true" }))));
        });
        const vintagePills = vintage
            .split(',')
            .filter((x) => { return x.length > 0; })
            .map((item, index) => {
            return (React.createElement("li", { key: index, className: "filter-pills__list__item" },
                React.createElement("button", { className: "pill" },
                    React.createElement("span", null, item),
                    React.createElement("i", { onClick: () => { this.props.updateSubFilter(item.trim(), "vintage"); }, className: "fa fa-times", "aria-hidden": "true" }))));
        });
        const varietalPills = varietal
            .split(',')
            .filter((x) => { return x.length > 0; })
            .map((item, index) => {
            return (React.createElement("li", { key: index, className: "filter-pills__list__item" },
                React.createElement("button", { className: "pill" },
                    React.createElement("span", null, item),
                    React.createElement("i", { onClick: () => { this.props.updateSubFilter(item.trim(), "ConsumerVarietal"); }, className: "fa fa-times", "aria-hidden": "true" }))));
        });
        let combined = country + region + vintage + varietal;
        let style = {
            display: combined.length > 0 ? "flex" : "none"
        };
        return (combined.length > 0 ? React.createElement("nav", { className: "filter-pills" },
            React.createElement("span", { className: "filter-pills__label" }, "Filters:"),
            React.createElement("ul", { className: "filter-pills__list" },
                countryPills,
                regionPills,
                vintagePills,
                varietalPills,
                React.createElement("li", { className: "filter-pills__list__item" },
                    React.createElement("button", { className: "clear-all", onClick: () => { this.props.clearAll(); } }, "Clear All")))) : null);
    }
}
;
//# sourceMappingURL=pill-filter.js.map